/**
 * Created by naorsolomon
 * Date: 08/04/2019
 */
import React from 'react';
import classnames from 'classnames/bind';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { RadioIcon } from 'taboola-ultimate-ui';
import { useBudgetRecommendation } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useBudgetRecommendation';
import { ChatAgentThemeWrapper } from '../../../../../../../themes/ChatAgentThemeWrapper';
import { GTM_EVENTS } from '../../../../../../taboola-common-frontend-modules/gtmTracker';
import BudgetData from './BudgetData/BudgetData';
import styles from './budgetRadioChoice.module.scss';

const classNameBuilder = classnames.bind(styles);

const BudgetRadioChoice = ({
    onBudgetChange,
    iconComponent,
    title,
    type,
    className,
    containerClassName,
    onMouseEnter,
    onMouseLeave,
    failedValidationData,
    skipBudgetData,
    value,
    ...rest
}) => {
    const { recommendation } = useBudgetRecommendation();
    const hasRecommendation = isEmpty(value) && recommendation?.type === type;
    return (
        <div className={containerClassName}>
            <ChatAgentThemeWrapper disabled={!hasRecommendation}>
                <RadioIcon
                    {...rest}
                    value={type}
                    title={title}
                    labelClassName={classNameBuilder(className, { recommendation: hasRecommendation })}
                    iconComponent={iconComponent}
                    onMouseEnter={() => onMouseEnter(type)}
                    onMouseLeave={() => onMouseLeave(type)}
                    data-metrics-value={type}
                    data-metrics-event-name={GTM_EVENTS.USABILITY}
                >
                    {!skipBudgetData && (
                        <BudgetData
                            {...rest}
                            onBudgetChange={onBudgetChange}
                            type={type}
                            failedValidationData={failedValidationData}
                            value={value}
                        />
                    )}
                </RadioIcon>
            </ChatAgentThemeWrapper>
        </div>
    );
};

BudgetRadioChoice.propTypes = {
    onBudgetChange: PropTypes.func.isRequired,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.node,
    title: PropTypes.node,
    iconComponent: PropTypes.node,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    currency: PropTypes.string,
    failedValidationData: PropTypes.object,
};

BudgetRadioChoice.defaultProps = {
    className: '',
    onMouseEnter: () => {},
    onMouseLeave: () => {},
};

export default BudgetRadioChoice;
